<template>
  <el-container>
    <Navbar />
    <div class="contentContainer">
      <el-container>
        <el-main :class="['mymain', !isHome ? 'bg-black' : '', 'mymain3']">
          <!-- 面包屑导航 -->
          <Index v-if="!isHome"></Index>
          <el-tabs
            v-model="$store.state.activeIndex"
            type="border-card"
            style="margin-top: 0px; width: 100%"
            closable
            v-if="$store.state.openTab.length && isHome"
            @tab-click="tabClick"
            @tab-remove="tabRemove"
          >
            <!-- 获取vuex中的openTab数组数据，循环展示 -->
            <el-tab-pane
              :key="index"
              v-for="(item, index) in $store.state.openTab"
              :label="item.name"
              :name="item.route"
            >
              <keep-alive>
                <router-view :key="$route.fullPath"></router-view>
              </keep-alive>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </div>
  </el-container>
</template>

<script>
import moment from "moment";
import Index from "@/dash/index.vue";
import iconfont from "@/assets/iconfont/iconfont.css";
import Navbar from "@/layout/components/Navbar.vue";
export default {
  data() {
    return {
      isHome: false,
    };
  },
  components: {
    Index,
    Navbar,
  },
  computed: {},
  created() {
    moment.locale("ZH_cn");
  },
  methods: {
    //tab标签点击时，切换相应的路由
    tabClick(tab) {
      this.$router.push({ path: this.$store.state.activeIndex });
    },
    //移除tab标签
    tabRemove(targetName) {
      //首页不删
      if (targetName == "/processManager") {
        return;
      }
      this.$store.commit("delete_tabs", targetName);
      if (this.$store.state.activeIndex === targetName) {
        // 设置删除后，重新激活的路径
        if (
          this.$store.state.openTab &&
          this.$store.state.openTab.length >= 1
        ) {
          //设置路由展示，为索引前一个路由
          this.$store.commit(
            "set_active_index",
            this.$store.state.openTab[this.$store.state.openTab.length - 1]
              .route
          );
          //跳转路由
          this.$router.push({ path: this.$store.state.activeIndex });
        } else {
          //否则 跳转到首页
          this.$router.push({ path: "/processManager" });
        }
      }
    },

    //查找当前路由
    seekCurrentRoute(data, path) {
      if (Array.isArray(data) && data.length > 0 && path && path != "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].route && data[i].route != "" && data[i].route == path) {
            return data[i].menuName;
          }

          if (
            Array.isArray(data[i].childList) &&
            data[i].childList.length > 0
          ) {
            let menuName = this.seekCurrentRoute(data[i].childList, path);
            if (menuName && menuName != "") {
              return menuName;
            }
          }
        }
      }
      return "";
    },
  },
  mounted() {
    // 刷新时以当前路由做为tab加入tabs
    // 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
    // 当当前路由是首页时，添加首页到store，并设置激活状态
    if (this.$route.path !== "/" && this.$route.path !== "/processManager") {
      this.$store.commit("set_active_index", this.$route.path);
      this.$store.commit("add_tabs", {
        route: this.$route.path,
        name: this.seekCurrentRoute(
          JSON.parse(localStorage.getItem("routeMenu")),
          this.$route.path
        ),
      });
      this.$router.push(this.$route.path);
      this.isHome = true;
    } else {
      this.$router.push("/processManager");
      this.isHome = false;
    }
  },
  watch: {
    $route(to, from) {
      //判断路由是否已经打开
      //已经打开的 ，将其置为active
      //未打开的，将其放入队列里
      let flag = false;
      if (to.path !== "/" && to.path !== "/processManager") {
        this.isHome = true;
      } else {
        this.isHome = false;
      }
      for (let item of this.$store.state.openTab) {
        if (item.route === to.fullPath) {
          this.$store.commit("set_active_index", to.fullPath);
          break;
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
html,
body,
#app {
  width: 100% !important;
  height: 100% !important;
}

.menu-switch {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor: pointer;
  background: rgb(47, 83, 235);

  i {
    color: #fff;
    font-size: 25px;
  }
}

.myheader {
  width: 100%;
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: fixed;
}

.head {
  position: absolute;
  top: 65px;
  left: 250px;
  width: calc(100% - 280px);
  height: 60px;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: center;
}

.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}

.el-drawer {
  outline: none;
}

.el-aside {
  background-color: #fff;
  color: #333;
  /* text-align: center; */
  /* line-height: 200px;
  height: 100%; */
}

.contentContainer .el-aside::-webkit-scrollbar {
  display: none;
}

.mymain {
  width: 100% !important;
  background-color: rgb(240, 242, 245);
  color: #333;
  margin-left: 200px;
}

.mymain3 {
  margin-left: 0;
}
.mymain2 {
  margin-left: 65px !important;
  transition: margin-left 0.28s;
}

.bg-black {
  background-color: #000;
  padding: 10px;
}

body .el-container {
  height: 100%;
}

.contentContainer {
  height: calc(100% - 60px);
  overflow: hidden;
  margin-top: 60px;
  min-width: 100%;
}

.contentContainer .el-container {
  height: 100%;
}

/* .el-container:nth-child(5) .el-aside, */
/* .el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
} */

/* 输入框禁用颜色微调 */
.el-input.is-disabled .el-input__inner {
  color: #666666;
}

/* 美化滚动条 */
/* 滚动条 */
::-webkit-scrollbar-track-piece {
  background-color: rgba(153, 153, 153, 0.5);
  /*滚动条的背景颜色*/
  -webkit-border-radius: 0;
  /*滚动条的圆角宽度*/
}

::-webkit-scrollbar {
  width: 10px;
  /*滚动条的宽度*/
  height: 8px;
  /*滚动条的高度*/
}

::-webkit-scrollbar-thumb:vertical {
  /*垂直滚动条的样式*/
  height: 50px;
  background-color: rgba(153, 153, 153, 0.5);
  -webkit-border-radius: 4px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
}

::-webkit-scrollbar-thumb {
  /*滚动条的hover样式*/
  background-color: rgba(159, 159, 159, 0.3);
  -webkit-border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  /*滚动条的hover样式*/
  background-color: rgba(159, 159, 159, 0.5);
  -webkit-border-radius: 4px;
}

/* tooltip全局样式 */
.el-tooltip__popper.is-dark {
  background: white;
  color: black;
  /* width: 500px; */
  font-size: 16px;
  line-height: 25px;
}

.myHead,
.head {
  top: 65px !important;
}
</style>

<style scoped>
.q-header-right {
  margin-left: 20px;
  margin-top: auto;
}

.el-input__inner {
  background: #2f53eb;
  border: none;
}

.el-scrollbar {
  background: #1b1f32;
}

.el-select-dropdown__item {
  color: white;
  background-color: #1b1f32;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #2f53eb;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 0px;
}

.el-select-dropdown {
  margin-top: 0px;
  border: none;
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}

.el-header .h_center p {
  -webkit-margin-before: 0.5em;
  margin-block-start: 0.5em;
  -webkit-margin-after: 0.5em;
  margin-block-end: 0.5em;
  -webkit-margin-start: 0;
  margin-inline-start: 0;
  -webkit-margin-end: 0;
  margin-inline-end: 0;
}

.el-header .h_center {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 300px;
  line-height: 1.15;
}

.el-header .timetable {
  color: #fff;
  text-align: right;
  margin-right: 10px;
  font-size: 16px;
}

.el-header .date {
  font-family: "\5FAE\8F6F\96C5\9ED1   Bold", "\5FAE\8F6F\96C5\9ED1";
  font-size: 16px;
  font-weight: 400;
}

.el-header .week {
  font-family: "\5FAE\8F6F\96C5\9ED1   Regular", "\5FAE\8F6F\96C5\9ED1";
  font-size: 12px;
  font-weight: 400;
}

.el-header .time {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: "\5FAE\8F6F\96C5\9ED1   Bold", "\5FAE\8F6F\96C5\9ED1";
  font-weight: 700;
  height: 60px;
  font-size: 24px;
}

.el-header .time p {
  font-family: Arial Normal, Arial;
  background: #00051f;
  color: #fff;
  font-size: 24px;
  padding: 5px 5px;
  border: 1px solid #2f53eb;
  border-radius: 2px;
}

.el-header .time span {
  color: #fff;
  padding: 5px;
  margin: auto 0;
}

.top-user {
  margin-right: 10px;
}

.el-dropdown {
  width: 100%;
  height: 100%;
}

.user {
  border: 0;
  color: #c1c6c8;
  font-size: 16px;
}

.el-dropdown-menu {
  margin: 0;
  width: 175px;
  background-color: #1b1f32;
  border-radius: 0;
  border: none;
  padding: 0;
  margin-right: -30px;
}

.el-dropdown-menu__item,
.el-dropdown > button > span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.el-dropdown-menu__item {
  font-size: 14px;
  line-height: 30px;
  color: #fff;
  padding: 10px 20px;
}

.el-dropdown[data-v-7a98ba65] {
  width: 100%;
  height: 100%;
}

.myheader {
  line-height: 1.15;
  width: 100%;
  height: 60px;
  top: 0;
  background: #1b1f32;
  z-index: 99;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.myheader .topbar-text {
  line-height: 60px;
  font-size: 20px;
  font-weight: 400;
  color: #fff;
}

.el-dropdown-menu__item:hover {
  background-color: #2f53eb;
  color: #fff;
}
</style>
<style >
.el-header .el-select .el-input.is-focus .el-input__inner {
  border-color: ;
}

.el-header .el-select-dropdown__list {
  background-color: #1b1f32;
}

.el-header .el-popper[x-placement^="bottom"] {
  margin-top: 0;
}

.el-header .el-select-dropdown {
  border: none;
}

.el-header .el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}

.el-header .el-select .el-input .el-input__inner {
  background: #2f53eb;
  color: rgb(255, 255, 255);
  border: none;
  font-size: 16px;
  text-align: center;
}

.el-header .el-select .el-input .el-input__inner::placeholder {
  color: rgb(255, 255, 255);
}

.el-header .line {
  display: inline-block;
  background-color: #617086;
  height: 40px;
  width: 1px;
  margin: 10px 20px;
}

.fixed-header {
  width: 200px;
}

.soli-header {
  width: 65px;
  transition: width 0.28s;
}
</style>
